module.exports = __webpack_public_path__ + "static/media/resetProfile.da883544.png";